export enum APP_MODALS_ALIAS {
  CONFIRMATION = 'confirmation',
}
